import { combineReducers } from '@reduxjs/toolkit';

import session, { SessionState } from './session-slice';
import user from './user-slice';
import { UserSchemaType } from './user.schema';

const reducer = combineReducers({
    session,
    user,
});

export type AuthState = {
    session: SessionState;
    user: UserSchemaType;
};

export * from './session-slice';
export * from './user-slice';
export * from './refresh-session-helper';

export default reducer;
